export default __webpack_public_path__ + "static/media/empty-wishlist.8280daf6.png";